// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ======================
   AssetDetailPage Styles
   ====================== */

.asset-detail-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  background: var(--color-bg-root);
}

/* ── Header ── */
.asset-detail-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 20px;
  border-bottom: 1px solid var(--color-border-input);
  flex-shrink: 0;
  min-height: 0;
}

.asset-detail-back-link {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 600;
  color: var(--color-text-secondary);
  text-decoration: none;
  transition: color 0.15s ease;
  flex-shrink: 0;
}

.asset-detail-back-link:hover {
  color: var(--color-text-primary);
}

.asset-detail-loading--fullscreen,
.asset-detail-error--fullscreen {
  height: 100vh;
  background: var(--color-bg-root);
}

/* Keep the editor's shape in place while its full asset record loads. */
.asset-detail-loading-shell {
  display: grid;
  grid-template-columns: 420px minmax(0, 1fr) 300px;
  width: 100%;
  height: 100vh;
  min-height: 0;
  overflow: hidden;
  background: var(--color-bg-root);
  color: var(--color-text-primary);
}

.asset-detail-loading-tools,
.asset-detail-loading-details {
  min-width: 0;
  background: var(--color-bg-sidebar);
}

.asset-detail-loading-tools {
  border-right: 1px solid var(--color-border-input);
}

.asset-detail-loading-details {
  border-left: 1px solid var(--color-border-input);
}

.asset-detail-loading-header {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 57px;
  padding: 0 16px;
  box-sizing: border-box;
  border-bottom: 1px solid var(--color-border-input);
}

.asset-detail-loading-back {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex: 0 0 auto;
  padding: 0;
  border: 1px solid var(--color-border-input);
  border-radius: 3px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.asset-detail-loading-back:hover {
  background: var(--color-bg-user-bubble);
  border-color: var(--color-text-secondary);
}

.asset-detail-loading-back:focus-visible {
  outline: 2px solid var(--color-text-secondary);
  outline-offset: 2px;
}

.asset-detail-loading-title {
  min-width: 0;
  overflow: hidden;
  color: var(--color-text-primary);
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-size: 20px;
  font-weight: 500;
  line-height: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Editable asset title in the image editor header. Keep this local to the
   asset detail route instead of depending on the project sidebar's CSS. */
.asset-detail-editor-name-input {
  display: block;
  width: 100%;
  min-width: 0;
  height: 34px;
  padding: 4px 8px;
  box-sizing: border-box;
  overflow: hidden;
  border: 1px solid transparent;
  border-radius: 5px;
  outline: none;
  background: transparent;
  color: var(--color-text-primary);
  font: 500 20px/1.2 'Geist Sans', 'Times New Roman', serif;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.asset-detail-editor-name-input:hover {
  background: var(--color-bg-input);
}

.asset-detail-editor-name-input:focus {
  border-color: var(--color-border-input);
  background: var(--color-bg-input);
  text-overflow: clip;
}

.asset-detail-editor-name-input:focus-visible {
  outline: 2px solid var(--color-text-secondary);
  outline-offset: 1px;
}

.asset-detail-editor-name-input::placeholder {
  color: var(--color-text-secondary);
  font-weight: 400;
}

.asset-detail-loading-tool-list {
  padding: 18px 16px;
}

.asset-detail-loading-section-label {
  margin-bottom: 12px;
  color: var(--color-text-secondary);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.asset-detail-loading-tool-row {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 38px;
  padding: 0 8px;
  border-radius: 4px;
}

.asset-detail-loading-tool-icon,
.asset-detail-loading-send,
.asset-detail-loading-variation-thumb,
.asset-detail-loading-line {
  position: relative;
  display: block;
  overflow: hidden;
  background: var(--color-bg-input);
}

.asset-detail-loading-tool-icon::after,
.asset-detail-loading-send::after,
.asset-detail-loading-variation-thumb::after,
.asset-detail-loading-line::after,
.asset-detail-loading-text-block::after {
  position: absolute;
  inset: 0;
  background: linear-gradient(100deg, transparent 15%, rgba(255, 255, 255, 0.07) 45%, transparent 75%);
  content: '';
  transform: translateX(-100%);
  animation: assetDetailShimmer 1.8s ease-in-out infinite;
}

.asset-detail-loading-tool-icon {
  width: 24px;
  height: 24px;
  flex: 0 0 auto;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
}

.asset-detail-loading-line {
  height: 8px;
  border-radius: 999px;
}

.asset-detail-loading-line--short { width: 68px; }
.asset-detail-loading-line--medium { width: 104px; }
.asset-detail-loading-line--long { width: 82%; }

.asset-detail-loading-main {
  display: grid;
  grid-template-rows: minmax(0, 1fr) auto;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}

.asset-detail-loading-canvas {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  min-height: 0;
  margin: 24px 24px 12px;
  overflow: hidden;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-canvas-surface);
}

.asset-detail-loading-image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  opacity: 0.82;
  filter: saturate(0.9);
  animation: assetDetailImageIn 0.25s ease-out both;
}

.asset-detail-loading-image-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: min(54%, 460px);
  aspect-ratio: 4 / 3;
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  background: var(--color-bg-input);
  color: var(--color-text-secondary);
  opacity: 0.55;
}

.asset-detail-loading-status {
  position: absolute;
  left: 50%;
  bottom: 22px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 34px;
  padding: 0 13px;
  border: 1px solid var(--color-border-input);
  border-radius: 999px;
  background: var(--color-bg-sidebar);
  background: color-mix(in srgb, var(--color-bg-sidebar) 88%, transparent);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);
  color: var(--color-text-secondary);
  font-size: 12px;
  font-weight: 600;
  transform: translateX(-50%);
  backdrop-filter: blur(12px);
}

.asset-detail-loading-prompt {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 54px;
  margin: 0 16px 16px;
  padding: 0 13px;
  box-sizing: border-box;
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
  background: var(--color-bg-input);
  color: var(--color-text-secondary);
}

.asset-detail-loading-line--prompt {
  width: min(360px, 55%);
}

.asset-detail-loading-send {
  width: 28px;
  height: 28px;
  margin-left: auto;
  border: 1px solid var(--color-border-input);
  border-radius: 5px;
}

.asset-detail-loading-details-section {
  padding: 18px 16px;
  border-bottom: 1px solid var(--color-border-input);
}

.asset-detail-loading-text-block {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 11px;
  min-height: 94px;
  padding: 14px;
  box-sizing: border-box;
  overflow: hidden;
  border: 1px solid var(--color-border-input);
  border-radius: 7px;
  background: var(--color-bg-input);
}

.asset-detail-loading-variation {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px;
  border: 1px solid var(--color-border-input);
  border-radius: 5px;
}

.asset-detail-loading-variation-thumb {
  width: 42px;
  height: 42px;
  flex: 0 0 auto;
  border-radius: 3px;
}

@keyframes assetDetailShimmer {
  60%, 100% { transform: translateX(100%); }
}

@keyframes assetDetailImageIn {
  from { opacity: 0; transform: scale(0.99); }
  to { opacity: 0.82; transform: scale(1); }
}

@media (max-width: 1100px) {
  .asset-detail-loading-shell {
    grid-template-columns: 340px minmax(0, 1fr) 260px;
  }
}

@media (max-width: 860px) {
  .asset-detail-loading-shell {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: auto minmax(0, 1fr);
  }

  .asset-detail-loading-tools {
    border-right: 0;
  }

  .asset-detail-loading-tool-list,
  .asset-detail-loading-details {
    display: none;
  }

  .asset-detail-loading-main {
    min-height: 0;
  }

  .asset-detail-loading-canvas {
    margin-top: 16px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .asset-detail-loading-image,
  .asset-detail-loading-tool-icon::after,
  .asset-detail-loading-send::after,
  .asset-detail-loading-variation-thumb::after,
  .asset-detail-loading-line::after,
  .asset-detail-loading-text-block::after {
    animation: none;
  }
}

.asset-detail-editor-panel {
  display: flex;
  flex-direction: column;
  gap: 0;
  min-height: 100%;
}

.asset-detail-editor-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border-bottom: 1px solid var(--color-border-input);
}

.asset-detail-editor-section .asset-detail-field-display {
  align-items: flex-start;
}

.asset-detail-editor-section .asset-detail-name-text,
.asset-detail-editor-section .asset-detail-prompt-text {
  white-space: normal;
  max-width: none;
}

.asset-detail-editor-section .asset-detail-field-edit-row {
  align-items: flex-start;
}

.asset-detail-editor-section .asset-detail-name-input,
.asset-detail-editor-section .asset-detail-desc-input {
  min-width: 0;
  width: 100%;
}

.asset-detail-editor-section .asset-detail-delete-btn {
  justify-content: center;
}

.asset-detail-header-meta {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.asset-detail-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.asset-detail-header-error {
  font-size: 12px;
  color: #dc2626;
}

/* ── Name & desc in header ── */
.asset-detail-field-display {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  min-width: 0;
}

.asset-detail-desc-display {
  align-items: flex-start;
}

.asset-detail-edit-icon {
  opacity: 0;
  color: var(--color-text-secondary);
  flex-shrink: 0;
  transition: opacity 0.15s ease;
}

.asset-detail-field-display:hover .asset-detail-edit-icon {
  opacity: 1;
}

.asset-detail-name-text {
  font-size: 15px;
  font-weight: 700;
  color: var(--color-text-primary);
  letter-spacing: -0.2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.asset-detail-prompt-text {
  font-size: 12px;
  color: var(--color-text-secondary);
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 480px;
}

.asset-detail-prompt-empty {
  font-style: italic;
  opacity: 0.5;
}

.asset-detail-field-edit-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.asset-detail-field-edit-col {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.asset-detail-name-input {
  padding: 4px 8px;
  border: 1px solid var(--color-border-input);
  border-radius: 3px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 15px;
  font-weight: 700;
  font-family: inherit;
  min-width: 200px;
}

.asset-detail-name-input:focus {
  outline: none;
  border-color: var(--color-text-secondary);
}

.asset-detail-desc-input {
  padding: 4px 8px;
  border: 1px solid var(--color-border-input);
  border-radius: 3px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 12px;
  font-family: inherit;
  min-width: 280px;
}

.asset-detail-desc-input:focus {
  outline: none;
  border-color: var(--color-text-secondary);
}

.asset-detail-save-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 5px 10px;
  border-radius: 3px;
  border: 1px solid var(--color-text-primary);
  background: var(--color-text-primary);
  color: var(--color-bg-canvas-surface);
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: opacity 0.15s ease;
}

.asset-detail-save-btn:hover:not(:disabled) { opacity: 0.85; }
.asset-detail-save-btn:disabled { opacity: 0.4; cursor: not-allowed; }

.asset-detail-cancel-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 5px 8px;
  border-radius: 3px;
  border: 1px solid var(--color-border-input);
  background: transparent;
  color: var(--color-text-secondary);
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.asset-detail-cancel-btn:hover {
  background: var(--color-bg-input);
  color: var(--color-text-primary);
}

/* ── Delete ── */
.asset-detail-delete-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 12px;
  border-radius: 3px;
  border: 1px solid var(--color-border-input);
  background: transparent;
  color: var(--color-text-secondary);
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.asset-detail-delete-btn:hover {
  background: rgba(220, 38, 38, 0.08);
  color: #dc2626;
  border-color: rgba(220, 38, 38, 0.3);
}

.asset-detail-delete-confirm {
  display: flex;
  align-items: center;
  gap: 8px;
}

.asset-detail-delete-confirm > span {
  font-size: 12px;
  color: var(--color-text-secondary);
}

.asset-detail-delete-confirm-yes {
  padding: 5px 10px;
  border-radius: 3px;
  border: 1px solid rgba(220, 38, 38, 0.4);
  background: rgba(220, 38, 38, 0.08);
  color: #dc2626;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
}

.asset-detail-delete-confirm-yes:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.asset-detail-delete-confirm-no {
  padding: 5px 10px;
  border-radius: 3px;
  border: 1px solid var(--color-border-input);
  background: transparent;
  color: var(--color-text-secondary);
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
}

/* ── Body (image + sidebar) ── */
.asset-detail-body {
  flex: 1 1;
  min-height: 0;
  display: flex;
  overflow: hidden;
}

/* ── Left: image + prompt ── */
.asset-detail-left {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  overflow-y: auto;
}

.asset-detail-media-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex: 1 1;
  min-height: 200px;
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  overflow: hidden;
  background: var(--color-bg-canvas-surface);
}

.asset-detail-full-image {
  display: block;
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  -webkit-user-select: none;
          user-select: none;
  -webkit-user-drag: none;
}

.asset-detail-image-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 60px 24px;
  color: var(--color-text-secondary);
  opacity: 0.4;
  font-size: 13px;
}

.asset-detail-generating-overlay {
  position: absolute;
  inset: 0;
  background: var(--color-bg-canvas-surface);
  opacity: 0.7;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

/* ── Pending preview ── */
.asset-detail-pending-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-sidebar);
  flex-shrink: 0;
}

.asset-detail-pending-label {
  font-size: 12px;
  color: var(--color-text-secondary);
  flex: 1 1;
}

.asset-detail-accept-btn,
.asset-detail-discard-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 12px;
  border-radius: 3px;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.15s ease, opacity 0.15s ease;
}

.asset-detail-accept-btn {
  border: 1px solid var(--color-text-primary);
  background: var(--color-text-primary);
  color: var(--color-bg-canvas-surface);
}

.asset-detail-accept-btn:hover { opacity: 0.85; }

.asset-detail-discard-btn {
  border: 1px solid var(--color-border-input);
  background: transparent;
  color: var(--color-text-secondary);
}

.asset-detail-discard-btn:hover {
  background: var(--color-bg-input);
  color: var(--color-text-primary);
}

/* ── Edit prompt box ── */
.asset-detail-edit-panel {
  flex-shrink: 0;
}

/* ── Right: variations sidebar ── */
.asset-detail-sidebar {
  width: 260px;
  flex-shrink: 0;
  border-left: 1px solid var(--color-border-input);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.asset-detail-sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px 12px;
  border-bottom: 1px solid var(--color-border-input);
  flex-shrink: 0;
}

.asset-detail-sidebar-title {
  font-size: 12px;
  font-weight: 700;
  color: var(--color-text-primary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.asset-detail-add-sub-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 5px 10px;
  border-radius: 3px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-secondary);
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.asset-detail-add-sub-btn:hover {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

.asset-detail-sidebar-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.asset-detail-sub-empty {
  font-size: 12px;
  color: var(--color-text-secondary);
  margin: 0;
  padding: 12px 0;
  opacity: 0.6;
}

.asset-detail-sub-create-wrapper {
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  overflow: hidden;
}

.asset-detail-sub-create-fullscreen {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
  background: var(--color-bg-root);
  z-index: 50;
  overflow: auto;
}

.asset-detail-sub-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.asset-detail-sub-card {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  overflow: hidden;
  background: var(--color-bg-sidebar);
  transition: border-color 0.15s ease;
  padding-right: 10px;
}

.asset-detail-sub-card:hover {
  border-color: var(--color-text-secondary);
}

.asset-detail-sub-image-wrapper {
  width: 52px;
  height: 52px;
  flex-shrink: 0;
  background: var(--color-bg-canvas-surface);
  overflow: hidden;
}

.asset-detail-sub-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.asset-detail-sub-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-secondary);
  opacity: 0.3;
}

.asset-detail-sub-name {
  font-size: 12px;
  font-weight: 500;
  color: var(--color-text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1;
  min-width: 0;
}

/* ── Loading / error ── */
.asset-detail-loading,
.asset-detail-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  height: 100%;
  color: var(--color-text-secondary);
  font-size: 14px;
}

.asset-detail-error-msg {
  padding: 8px 12px;
  border-radius: 3px;
  border: 1px solid rgba(220, 38, 38, 0.3);
  background: rgba(220, 38, 38, 0.06);
  color: #dc2626;
  font-size: 12px;
}

/* ── Spinner ── */
.asset-detail-spinner {
  animation: assetDetailSpin 0.8s linear infinite;
}

@keyframes assetDetailSpin {
  to { transform: rotate(360deg); }
}

/* ── Responsive ── */
@media (max-width: 768px) {
  .asset-detail-body {
    flex-direction: column;
  }
  .asset-detail-sidebar {
    width: 100%;
    border-left: none;
    border-top: 1px solid var(--color-border-input);
    max-height: 300px;
  }
}
.asset-detail-description-panel {
  border-bottom: 1px solid var(--color-border-input);
}

.asset-detail-description-input {
  box-sizing: border-box;
  width: 100%;
  min-height: 110px;
  resize: vertical;
  border: 1px solid var(--color-border-input);
  border-radius: 7px;
  padding: 9px 10px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font: inherit;
  font-size: 12px;
  line-height: 1.45;
  outline: none;
}

.asset-detail-description-input:focus {
  border-color: var(--color-accent-base);
  box-shadow: 0 0 0 3px var(--color-focus-ring);
}
`, "",{"version":3,"sources":["webpack://./src/AssetDetailPage.css"],"names":[],"mappings":"AAAA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kDAAkD;EAClD,cAAc;EACd,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,qBAAqB;EACrB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,aAAa;EACb,gCAAgC;AAClC;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,iDAAiD;EACjD,WAAW;EACX,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;;EAEE,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kDAAkD;AACpD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,UAAU;EACV,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;AAC3C;;AAEA;EACE,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;0EAC0E;AAC1E;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,gCAAgC;EAChC,yDAAyD;EACzD,uBAAuB;EACvB,mBAAmB;EACnB,gEAAgE;AAClE;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;EACvC,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;;EAIE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;;;;;EAKE,kBAAkB;EAClB,QAAQ;EACR,oGAAoG;EACpG,WAAW;EACX,4BAA4B;EAC5B,uDAAuD;AACzD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA,oCAAoC,WAAW,EAAE;AACjD,qCAAqC,YAAY,EAAE;AACnD,mCAAmC,UAAU,EAAE;;AAE/C;EACE,aAAa;EACb,uCAAuC;EACvC,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,oBAAoB;EACpB,mCAAmC;EACnC,wEAAwE;EACxE,0CAA0C;EAC1C,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY,2BAA2B,EAAE;AAC3C;;AAEA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,KAAK,aAAa,EAAE,mBAAmB,EAAE;AAC3C;;AAEA;EACE;IACE,iDAAiD;EACnD;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,uCAAuC;EACzC;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;;;;;;IAME,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,kDAAkD;AACpD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,kCAAkC;EAClC,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,8BAA8B;AAChC;;AAEA,8CAA8C,aAAa,EAAE;AAC7D,kCAAkC,YAAY,EAAE,mBAAmB,EAAE;;AAErE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,mCAAmC;EACnC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,SAAO;EACP,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,0CAA0C;EAC1C,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,SAAO;AACT;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA,iCAAiC,aAAa,EAAE;;AAEhD;EACE,2CAA2C;EAC3C,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA,0BAA0B;AAC1B;EACE,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,YAAY;EACZ,cAAc;EACd,gDAAgD;EAChD,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,SAAS;EACT,eAAe;EACf,YAAY;AACd;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,SAAO;EACP,YAAY;AACd;;AAEA,0BAA0B;AAC1B;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,mCAAmC;EACnC,cAAc;EACd,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,+CAA+C;AACjD;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,qBAAqB;AACrB;EACE;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,+CAA+C;IAC/C,iBAAiB;EACnB;AACF;AACA;EACE,kDAAkD;AACpD;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,iBAAiB;EACjB,iCAAiC;EACjC,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,6CAA6C;AAC/C","sourcesContent":["/* ======================\n   AssetDetailPage Styles\n   ====================== */\n\n.asset-detail-page {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n  overflow: hidden;\n  background: var(--color-bg-root);\n}\n\n/* ── Header ── */\n.asset-detail-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 12px 20px;\n  border-bottom: 1px solid var(--color-border-input);\n  flex-shrink: 0;\n  min-height: 0;\n}\n\n.asset-detail-back-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--color-text-secondary);\n  text-decoration: none;\n  transition: color 0.15s ease;\n  flex-shrink: 0;\n}\n\n.asset-detail-back-link:hover {\n  color: var(--color-text-primary);\n}\n\n.asset-detail-loading--fullscreen,\n.asset-detail-error--fullscreen {\n  height: 100vh;\n  background: var(--color-bg-root);\n}\n\n/* Keep the editor's shape in place while its full asset record loads. */\n.asset-detail-loading-shell {\n  display: grid;\n  grid-template-columns: 420px minmax(0, 1fr) 300px;\n  width: 100%;\n  height: 100vh;\n  min-height: 0;\n  overflow: hidden;\n  background: var(--color-bg-root);\n  color: var(--color-text-primary);\n}\n\n.asset-detail-loading-tools,\n.asset-detail-loading-details {\n  min-width: 0;\n  background: var(--color-bg-sidebar);\n}\n\n.asset-detail-loading-tools {\n  border-right: 1px solid var(--color-border-input);\n}\n\n.asset-detail-loading-details {\n  border-left: 1px solid var(--color-border-input);\n}\n\n.asset-detail-loading-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  height: 57px;\n  padding: 0 16px;\n  box-sizing: border-box;\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.asset-detail-loading-back {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  flex: 0 0 auto;\n  padding: 0;\n  border: 1px solid var(--color-border-input);\n  border-radius: 3px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.asset-detail-loading-back:hover {\n  background: var(--color-bg-user-bubble);\n  border-color: var(--color-text-secondary);\n}\n\n.asset-detail-loading-back:focus-visible {\n  outline: 2px solid var(--color-text-secondary);\n  outline-offset: 2px;\n}\n\n.asset-detail-loading-title {\n  min-width: 0;\n  overflow: hidden;\n  color: var(--color-text-primary);\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 1;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Editable asset title in the image editor header. Keep this local to the\n   asset detail route instead of depending on the project sidebar's CSS. */\n.asset-detail-editor-name-input {\n  display: block;\n  width: 100%;\n  min-width: 0;\n  height: 34px;\n  padding: 4px 8px;\n  box-sizing: border-box;\n  overflow: hidden;\n  border: 1px solid transparent;\n  border-radius: 5px;\n  outline: none;\n  background: transparent;\n  color: var(--color-text-primary);\n  font: 500 20px/1.2 'Geist Sans', 'Times New Roman', serif;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n}\n\n.asset-detail-editor-name-input:hover {\n  background: var(--color-bg-input);\n}\n\n.asset-detail-editor-name-input:focus {\n  border-color: var(--color-border-input);\n  background: var(--color-bg-input);\n  text-overflow: clip;\n}\n\n.asset-detail-editor-name-input:focus-visible {\n  outline: 2px solid var(--color-text-secondary);\n  outline-offset: 1px;\n}\n\n.asset-detail-editor-name-input::placeholder {\n  color: var(--color-text-secondary);\n  font-weight: 400;\n}\n\n.asset-detail-loading-tool-list {\n  padding: 18px 16px;\n}\n\n.asset-detail-loading-section-label {\n  margin-bottom: 12px;\n  color: var(--color-text-secondary);\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.asset-detail-loading-tool-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 38px;\n  padding: 0 8px;\n  border-radius: 4px;\n}\n\n.asset-detail-loading-tool-icon,\n.asset-detail-loading-send,\n.asset-detail-loading-variation-thumb,\n.asset-detail-loading-line {\n  position: relative;\n  display: block;\n  overflow: hidden;\n  background: var(--color-bg-input);\n}\n\n.asset-detail-loading-tool-icon::after,\n.asset-detail-loading-send::after,\n.asset-detail-loading-variation-thumb::after,\n.asset-detail-loading-line::after,\n.asset-detail-loading-text-block::after {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(100deg, transparent 15%, rgba(255, 255, 255, 0.07) 45%, transparent 75%);\n  content: '';\n  transform: translateX(-100%);\n  animation: assetDetailShimmer 1.8s ease-in-out infinite;\n}\n\n.asset-detail-loading-tool-icon {\n  width: 24px;\n  height: 24px;\n  flex: 0 0 auto;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n}\n\n.asset-detail-loading-line {\n  height: 8px;\n  border-radius: 999px;\n}\n\n.asset-detail-loading-line--short { width: 68px; }\n.asset-detail-loading-line--medium { width: 104px; }\n.asset-detail-loading-line--long { width: 82%; }\n\n.asset-detail-loading-main {\n  display: grid;\n  grid-template-rows: minmax(0, 1fr) auto;\n  min-width: 0;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.asset-detail-loading-canvas {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 0;\n  min-height: 0;\n  margin: 24px 24px 12px;\n  overflow: hidden;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-canvas-surface);\n}\n\n.asset-detail-loading-image {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  opacity: 0.82;\n  filter: saturate(0.9);\n  animation: assetDetailImageIn 0.25s ease-out both;\n}\n\n.asset-detail-loading-image-placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: min(54%, 460px);\n  aspect-ratio: 4 / 3;\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  background: var(--color-bg-input);\n  color: var(--color-text-secondary);\n  opacity: 0.55;\n}\n\n.asset-detail-loading-status {\n  position: absolute;\n  left: 50%;\n  bottom: 22px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 34px;\n  padding: 0 13px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 999px;\n  background: var(--color-bg-sidebar);\n  background: color-mix(in srgb, var(--color-bg-sidebar) 88%, transparent);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  font-weight: 600;\n  transform: translateX(-50%);\n  backdrop-filter: blur(12px);\n}\n\n.asset-detail-loading-prompt {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  height: 54px;\n  margin: 0 16px 16px;\n  padding: 0 13px;\n  box-sizing: border-box;\n  border: 1px solid var(--color-border-input);\n  border-radius: 8px;\n  background: var(--color-bg-input);\n  color: var(--color-text-secondary);\n}\n\n.asset-detail-loading-line--prompt {\n  width: min(360px, 55%);\n}\n\n.asset-detail-loading-send {\n  width: 28px;\n  height: 28px;\n  margin-left: auto;\n  border: 1px solid var(--color-border-input);\n  border-radius: 5px;\n}\n\n.asset-detail-loading-details-section {\n  padding: 18px 16px;\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.asset-detail-loading-text-block {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 11px;\n  min-height: 94px;\n  padding: 14px;\n  box-sizing: border-box;\n  overflow: hidden;\n  border: 1px solid var(--color-border-input);\n  border-radius: 7px;\n  background: var(--color-bg-input);\n}\n\n.asset-detail-loading-variation {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 5px;\n}\n\n.asset-detail-loading-variation-thumb {\n  width: 42px;\n  height: 42px;\n  flex: 0 0 auto;\n  border-radius: 3px;\n}\n\n@keyframes assetDetailShimmer {\n  60%, 100% { transform: translateX(100%); }\n}\n\n@keyframes assetDetailImageIn {\n  from { opacity: 0; transform: scale(0.99); }\n  to { opacity: 0.82; transform: scale(1); }\n}\n\n@media (max-width: 1100px) {\n  .asset-detail-loading-shell {\n    grid-template-columns: 340px minmax(0, 1fr) 260px;\n  }\n}\n\n@media (max-width: 860px) {\n  .asset-detail-loading-shell {\n    grid-template-columns: minmax(0, 1fr);\n    grid-template-rows: auto minmax(0, 1fr);\n  }\n\n  .asset-detail-loading-tools {\n    border-right: 0;\n  }\n\n  .asset-detail-loading-tool-list,\n  .asset-detail-loading-details {\n    display: none;\n  }\n\n  .asset-detail-loading-main {\n    min-height: 0;\n  }\n\n  .asset-detail-loading-canvas {\n    margin-top: 16px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .asset-detail-loading-image,\n  .asset-detail-loading-tool-icon::after,\n  .asset-detail-loading-send::after,\n  .asset-detail-loading-variation-thumb::after,\n  .asset-detail-loading-line::after,\n  .asset-detail-loading-text-block::after {\n    animation: none;\n  }\n}\n\n.asset-detail-editor-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  min-height: 100%;\n}\n\n.asset-detail-editor-section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px;\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.asset-detail-editor-section .asset-detail-field-display {\n  align-items: flex-start;\n}\n\n.asset-detail-editor-section .asset-detail-name-text,\n.asset-detail-editor-section .asset-detail-prompt-text {\n  white-space: normal;\n  max-width: none;\n}\n\n.asset-detail-editor-section .asset-detail-field-edit-row {\n  align-items: flex-start;\n}\n\n.asset-detail-editor-section .asset-detail-name-input,\n.asset-detail-editor-section .asset-detail-desc-input {\n  min-width: 0;\n  width: 100%;\n}\n\n.asset-detail-editor-section .asset-detail-delete-btn {\n  justify-content: center;\n}\n\n.asset-detail-header-meta {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.asset-detail-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.asset-detail-header-error {\n  font-size: 12px;\n  color: #dc2626;\n}\n\n/* ── Name & desc in header ── */\n.asset-detail-field-display {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  min-width: 0;\n}\n\n.asset-detail-desc-display {\n  align-items: flex-start;\n}\n\n.asset-detail-edit-icon {\n  opacity: 0;\n  color: var(--color-text-secondary);\n  flex-shrink: 0;\n  transition: opacity 0.15s ease;\n}\n\n.asset-detail-field-display:hover .asset-detail-edit-icon {\n  opacity: 1;\n}\n\n.asset-detail-name-text {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--color-text-primary);\n  letter-spacing: -0.2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.asset-detail-prompt-text {\n  font-size: 12px;\n  color: var(--color-text-secondary);\n  line-height: 1.4;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 480px;\n}\n\n.asset-detail-prompt-empty {\n  font-style: italic;\n  opacity: 0.5;\n}\n\n.asset-detail-field-edit-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.asset-detail-field-edit-col {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.asset-detail-name-input {\n  padding: 4px 8px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 3px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 15px;\n  font-weight: 700;\n  font-family: inherit;\n  min-width: 200px;\n}\n\n.asset-detail-name-input:focus {\n  outline: none;\n  border-color: var(--color-text-secondary);\n}\n\n.asset-detail-desc-input {\n  padding: 4px 8px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 3px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 12px;\n  font-family: inherit;\n  min-width: 280px;\n}\n\n.asset-detail-desc-input:focus {\n  outline: none;\n  border-color: var(--color-text-secondary);\n}\n\n.asset-detail-save-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 5px 10px;\n  border-radius: 3px;\n  border: 1px solid var(--color-text-primary);\n  background: var(--color-text-primary);\n  color: var(--color-bg-canvas-surface);\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: opacity 0.15s ease;\n}\n\n.asset-detail-save-btn:hover:not(:disabled) { opacity: 0.85; }\n.asset-detail-save-btn:disabled { opacity: 0.4; cursor: not-allowed; }\n\n.asset-detail-cancel-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 5px 8px;\n  border-radius: 3px;\n  border: 1px solid var(--color-border-input);\n  background: transparent;\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.asset-detail-cancel-btn:hover {\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n}\n\n/* ── Delete ── */\n.asset-detail-delete-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 6px 12px;\n  border-radius: 3px;\n  border: 1px solid var(--color-border-input);\n  background: transparent;\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.asset-detail-delete-btn:hover {\n  background: rgba(220, 38, 38, 0.08);\n  color: #dc2626;\n  border-color: rgba(220, 38, 38, 0.3);\n}\n\n.asset-detail-delete-confirm {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.asset-detail-delete-confirm > span {\n  font-size: 12px;\n  color: var(--color-text-secondary);\n}\n\n.asset-detail-delete-confirm-yes {\n  padding: 5px 10px;\n  border-radius: 3px;\n  border: 1px solid rgba(220, 38, 38, 0.4);\n  background: rgba(220, 38, 38, 0.08);\n  color: #dc2626;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.asset-detail-delete-confirm-yes:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.asset-detail-delete-confirm-no {\n  padding: 5px 10px;\n  border-radius: 3px;\n  border: 1px solid var(--color-border-input);\n  background: transparent;\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n/* ── Body (image + sidebar) ── */\n.asset-detail-body {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  overflow: hidden;\n}\n\n/* ── Left: image + prompt ── */\n.asset-detail-left {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 20px;\n  overflow-y: auto;\n}\n\n.asset-detail-media-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  flex: 1;\n  min-height: 200px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  overflow: hidden;\n  background: var(--color-bg-canvas-surface);\n}\n\n.asset-detail-full-image {\n  display: block;\n  max-width: 100%;\n  max-height: 100%;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n  user-select: none;\n  -webkit-user-drag: none;\n}\n\n.asset-detail-image-placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 60px 24px;\n  color: var(--color-text-secondary);\n  opacity: 0.4;\n  font-size: 13px;\n}\n\n.asset-detail-generating-overlay {\n  position: absolute;\n  inset: 0;\n  background: var(--color-bg-canvas-surface);\n  opacity: 0.7;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n}\n\n/* ── Pending preview ── */\n.asset-detail-pending-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 14px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-sidebar);\n  flex-shrink: 0;\n}\n\n.asset-detail-pending-label {\n  font-size: 12px;\n  color: var(--color-text-secondary);\n  flex: 1;\n}\n\n.asset-detail-accept-btn,\n.asset-detail-discard-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 6px 12px;\n  border-radius: 3px;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.15s ease, opacity 0.15s ease;\n}\n\n.asset-detail-accept-btn {\n  border: 1px solid var(--color-text-primary);\n  background: var(--color-text-primary);\n  color: var(--color-bg-canvas-surface);\n}\n\n.asset-detail-accept-btn:hover { opacity: 0.85; }\n\n.asset-detail-discard-btn {\n  border: 1px solid var(--color-border-input);\n  background: transparent;\n  color: var(--color-text-secondary);\n}\n\n.asset-detail-discard-btn:hover {\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n}\n\n/* ── Edit prompt box ── */\n.asset-detail-edit-panel {\n  flex-shrink: 0;\n}\n\n/* ── Right: variations sidebar ── */\n.asset-detail-sidebar {\n  width: 260px;\n  flex-shrink: 0;\n  border-left: 1px solid var(--color-border-input);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.asset-detail-sidebar-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 16px 12px;\n  border-bottom: 1px solid var(--color-border-input);\n  flex-shrink: 0;\n}\n\n.asset-detail-sidebar-title {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--color-text-primary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.asset-detail-add-sub-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 5px 10px;\n  border-radius: 3px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.asset-detail-add-sub-btn:hover {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n.asset-detail-sidebar-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.asset-detail-sub-empty {\n  font-size: 12px;\n  color: var(--color-text-secondary);\n  margin: 0;\n  padding: 12px 0;\n  opacity: 0.6;\n}\n\n.asset-detail-sub-create-wrapper {\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.asset-detail-sub-create-fullscreen {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  box-sizing: border-box;\n  background: var(--color-bg-root);\n  z-index: 50;\n  overflow: auto;\n}\n\n.asset-detail-sub-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.asset-detail-sub-card {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  overflow: hidden;\n  background: var(--color-bg-sidebar);\n  transition: border-color 0.15s ease;\n  padding-right: 10px;\n}\n\n.asset-detail-sub-card:hover {\n  border-color: var(--color-text-secondary);\n}\n\n.asset-detail-sub-image-wrapper {\n  width: 52px;\n  height: 52px;\n  flex-shrink: 0;\n  background: var(--color-bg-canvas-surface);\n  overflow: hidden;\n}\n\n.asset-detail-sub-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.asset-detail-sub-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--color-text-secondary);\n  opacity: 0.3;\n}\n\n.asset-detail-sub-name {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--color-text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1;\n  min-width: 0;\n}\n\n/* ── Loading / error ── */\n.asset-detail-loading,\n.asset-detail-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  height: 100%;\n  color: var(--color-text-secondary);\n  font-size: 14px;\n}\n\n.asset-detail-error-msg {\n  padding: 8px 12px;\n  border-radius: 3px;\n  border: 1px solid rgba(220, 38, 38, 0.3);\n  background: rgba(220, 38, 38, 0.06);\n  color: #dc2626;\n  font-size: 12px;\n}\n\n/* ── Spinner ── */\n.asset-detail-spinner {\n  animation: assetDetailSpin 0.8s linear infinite;\n}\n\n@keyframes assetDetailSpin {\n  to { transform: rotate(360deg); }\n}\n\n/* ── Responsive ── */\n@media (max-width: 768px) {\n  .asset-detail-body {\n    flex-direction: column;\n  }\n  .asset-detail-sidebar {\n    width: 100%;\n    border-left: none;\n    border-top: 1px solid var(--color-border-input);\n    max-height: 300px;\n  }\n}\n.asset-detail-description-panel {\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.asset-detail-description-input {\n  box-sizing: border-box;\n  width: 100%;\n  min-height: 110px;\n  resize: vertical;\n  border: 1px solid var(--color-border-input);\n  border-radius: 7px;\n  padding: 9px 10px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font: inherit;\n  font-size: 12px;\n  line-height: 1.45;\n  outline: none;\n}\n\n.asset-detail-description-input:focus {\n  border-color: var(--color-accent-base);\n  box-shadow: 0 0 0 3px var(--color-focus-ring);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
